/* eslint-disable max-len */
const React = require('react');

const Copy = ({ alt }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt || ''}>
    <path fillRule="evenodd" clipRule="evenodd" d="M17.8025 1H5.80066V3.4472H7.00066V2.2H16.6025V14.2288H15.4184V15.4288H17.8025V1ZM14.2018 4.59772H2.19995V19H14.2018V4.59772ZM3.39995 17.8V5.79772H13.0018V17.8H3.39995Z" fill="#009EE3" />
  </svg>
);

module.exports = Copy;
